import { ncaab2026Outcomes } from "./LandingDemoData"
import { LandingDemoNFLBracket as BaseBracket } from "./LandingDemoNFLBracket"

type Props = Parameters<typeof BaseBracket>[0]

export function LandingDemoNCAABBracket(
  props: Omit<
    Props,
    "title" | "outcomes" | "imageUrl" | "volume" | "progress" | "ends" | "dateStart" | "dateEnd" | "state" | "simulate"
  >,
) {
  return (
    <BaseBracket
      title="2026 March Madness Men's"
      outcomes={ncaab2026Outcomes}
      imageUrl="https://a.bracky.app/assets/covers/ncaab/ncaa-march-madness-2026.jpg"
      volume={400000}
      progress={0}
      ends={new Date("2026-04-06")}
      dateStart={new Date("2026-03-17")}
      dateEnd={new Date("2026-04-06")}
      state="live"
      simulate
      {...props}
    />
  )
}
